import { useSnackbar } from 'notistack';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useCreateListDataMutation } from '../../../api/apiSlice';
import FormikButton from '../../../components/formik/FormikButton';
import FormikInput from '../../../components/formik/FormikInput';
import FormikSelect from '../../../components/formik/FormikSelect';
import ExternalScreen from '../../../components/fragments/ExternalScreen';
import Form from '../../../components/utilities/Form';
import { videoTypeInputs } from '../../../enums';
import errorSnackbar from '../../../utils/errorSnackbar';

const validator = Yup.object().shape({
    title: Yup.string().min(5).required('Title is required'),
    description: Yup.string().min(10).required('Description is required'),
    type: Yup.string().required('Type is required'),
    link: Yup.string()
        .required()
        .when('type', {
            is: (type) => type === videoTypeInputs[1].value,
            then: Yup.string(),
            otherwise: Yup.string().matches(
                /^(https?:\/\/)?(www\.|m\.)?(youtube\.com|youtu\.be)\/.+$/,
                'Invalid YouTube URL'
            ),
        }),
});

export default function ScreenCreateService() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [createService, { isLoading }] = useCreateListDataMutation();

    return (
        <ExternalScreen title="Create Service">
            <Form
                onSubmit={async (values) => {
                    const { error, data } = await createService({
                        list: `/op/services`,
                        body: values,
                    });

                    errorSnackbar(error, enqueueSnackbar);

                    if (data) {
                        enqueueSnackbar('Successfully created service');
                        navigate(-1);
                    }
                }}
                validationSchema={validator}
                initialValues={{
                    title: '',
                    description: '',
                    type: '',
                    link: '',
                }}
            >
                <FormikInput name="title" label="Title" />
                <FormikInput
                    name="description"
                    label="Description"
                    multiline
                    rows={3}
                />
                <FormikSelect
                    name="type"
                    label="Video Type"
                    data={videoTypeInputs}
                />
                <FormikInput name="link" label="Video Link" />
                <div className="d-flex justify-content-end w-100">
                    <FormikButton loading={isLoading} variant="contained">
                        Create
                    </FormikButton>
                </div>
            </Form>
        </ExternalScreen>
    );
}
